import classNames from 'classnames';
import numeral from 'numeral';
import React from 'react';
import {connect} from 'react-redux';
import swal from 'sweetalert2';
import {fetchStatsTournamentsActiveUsers} from '../../../../../../actions/entities/statistics/tournaments';
import earthFlag from '../../../../../../assets/img/other/flag-earth.svg';
import Loader from '../../../../../../components/Loader';

class TournamentsActiveUsersWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {lang: 'ALL'};
  }

  fetchStats() {
    const {isFetching} = this.props;
    if (!isFetching) {
      this.props.dispatch(
        fetchStatsTournamentsActiveUsers(null, (type, error) =>
          swal({
            title: `Oops...`,
            type: 'error',
            html:
              `Something went wrong:<br/>"${type}"<br/>${error}<br/>` +
              `<pre><code>${JSON.stringify(error, undefined, 4)}</code></pre>`,
          }),
        ),
      );
    }
  }

  toggleLang(value) {
    const {lang} = this.state;

    if (lang === value) {
      this.setState({lang: 'ALL'});
    } else {
      this.setState({lang: value});
    }
  }

  renderTournamentsActiveUsers() {
    const {data, isFetching} = this.props;
    const {lang} = this.state;
    let table = data && data[lang];

    if (!isFetching && table) {
      const totalCurrent = table.active.current + table.inactive.current;
      const activeCurrentPercent = (table.active.current / totalCurrent) * 100;
      const inactiveCurrentPercent =
        (table.inactive.current / totalCurrent) * 100;

      return (
        table && (
          <div className="mb-4">
            <div className="mt-3 table-responsive">
              <table className="table table-bordered no-margin table-striped">
                <tbody>
                  <tr className="text-center">
                    <td className="text-left">Joueurs actifs en tournoi</td>
                    <td style={{width: '150px '}}>
                      {numeral(table.active.current).format('0')}
                    </td>
                    <td style={{width: '150px '}} className="text-center">
                      {numeral(activeCurrentPercent).format('0')} %
                    </td>
                  </tr>
                  <tr className="text-center">
                    <td className="text-left">
                      Joueurs au compte-gouttes en tournoi
                    </td>
                    <td style={{width: '150px '}}>
                      {numeral(table.inactive.current).format('0')}
                    </td>
                    <td style={{width: '150px '}} className="text-center">
                      {numeral(inactiveCurrentPercent).format('0')} %
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )
      );
    }
  }

  render() {
    const {lang} = this.state;
    const {isFetching} = this.props;

    return (
      <div id="userConnections-stats-widget">
        <div className="box">
          <div className="box-header with-border">
            <h3 className="box-title pull-left">
              <i className="fa fa-trophy" /> Nombre d'utilisateurs
            </h3>
            <br />
            Au moins 1 tounoi actif (éliminé ou pas) <br />
            Connecté dans les 15 derniers jours
          </div>
          <div className="box-body">
            <div className="text-center">
              <div className="inline lang">
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'FR',
                  })}
                  onClick={() => this.toggleLang('FR')}>
                  <span className="flag-icon flag-icon-fr" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'GB',
                  })}
                  onClick={() => this.toggleLang('GB')}>
                  <span className="flag-icon flag-icon-gb" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'ES',
                  })}
                  onClick={() => this.toggleLang('ES')}>
                  <span className="flag-icon flag-icon-es" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'OTHER',
                  })}
                  onClick={() => this.toggleLang('OTHER')}>
                  <img
                    src={earthFlag}
                    alt="Drapeau de la terre"
                    className="flag-img-btn"
                  />
                </button>
              </div>
              <button
                className="ml-2 inline btn btn-default"
                onClick={() => this.fetchStats()}>
                <i className="fa fa-refresh" />
              </button>
            </div>
          </div>
          {isFetching && <Loader />}
          {this.renderTournamentsActiveUsers()}
        </div>
      </div>
    );
  }
}

export default connect(
  state => state.app.statistics.tournamentsActiveUsers,
  dispatch => ({dispatch}),
)(TournamentsActiveUsersWidget);



// WEBPACK FOOTER //
// ./src/pages/Monitoring/Statistics/Widgets/Tournaments/Users/index.js